import React, { useEffect } from "react";
import { useApp } from "@/context/AppContext";
import { Award, Lock, Zap } from "lucide-react";

const ALL_BADGES = [
  ["curve_champion", "Curve Champion", "Master all Curve strokes"],
  ["loop_master", "Loop Master", "Master all Loop strokes"],
  ["lowercase_master", "Lowercase Master", "Complete Level 2"],
  ["uppercase_master", "Uppercase Master", "Complete Level 3"],
  ["connection_expert", "Connection Expert", "Complete Level 4"],
  ["word_writer", "Word Writer", "Complete Level 5"],
  ["sentence_star", "Sentence Star", "Complete Level 6"],
  ["independent_writer", "Independent Writer", "Complete Level 7"],
  ["cursive_champion", "Cursive Champion", "Complete every level"],
];

export default function Achievements() {
  const { overlay, refreshCurriculum } = useApp();
  useEffect(() => { refreshCurriculum && refreshCurriculum(); }, [refreshCurriculum]);
  const earned = new Set((overlay?.badges || []).map((b) => b.id));

  return (
    <div className="mx-auto max-w-4xl px-4 py-8 sm:px-6 sm:py-10">
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-[#1F2937]">Achievement Gallery</h1>
      <div className="mt-2 inline-flex items-center gap-2 rounded-full bg-[#F59E0B]/15 px-4 py-1.5 font-bold text-[#B45309]">
        <Zap size={16} /> {overlay?.points || 0} points · {earned.size} badges
      </div>

      <div className="mt-8 grid gap-4 sm:grid-cols-3">
        {ALL_BADGES.map(([id, name, desc]) => {
          const has = earned.has(id);
          return (
            <div key={id} data-testid={`badge-${id}`} className={`rounded-3xl border p-6 text-center transition-all ${has ? "border-[#F59E0B] bg-gradient-to-b from-[#F59E0B]/10 to-white" : "border-[#E5DECF] bg-[#F2ECE1]/40"}`}>
              <div className={`mx-auto flex h-16 w-16 items-center justify-center rounded-2xl ${has ? "bg-gradient-to-b from-[#F59E0B] to-[#D97706] text-white shadow-md" : "bg-[#E5DECF] text-[#94A3B8]"}`}>
                {has ? <Award size={30} /> : <Lock size={26} />}
              </div>
              <div className="mt-3 font-heading font-bold text-[#1F2937]">{name}</div>
              <div className="mt-1 font-body text-sm text-[#6B7280]">{desc}</div>
              {has && <div className="mt-2 text-xs font-bold uppercase tracking-wide text-[#B45309]">Earned</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
